import axios from '@/common/http.js';

var actions = {
	async getnewchapterlist({commit,state},param){
		let {data,code} = await axios.get('https://login.zhuoyuyun.com/index/jiaoxue.Chapter/getOneChapter',{
			params:param
		})
		for(let i=0; i<data.length; i++){
			data[i].value = data[i].id;
			data[i].label = data[i].title;
			data[i].leved = 2;
			data[i].children=[];
			data[i].lid=data[i].id + data[i].title;
			data[i].mid=data[i].id;
			data[i].leaf=false;
		}
		commit('setSetdata',{
			key:'ceshi',
			data:data
		})
	},
	//获取章节
	async getchapterlist({commit,state},param){
		let {data,code} = await axios.get('https://login.zhuoyuyun.com/index/jiaoxue.Chapter/getChapter',{
		params:param
		})
		if(code=='10001' && data.length>0){
			commit("setTrees",{ trees:data});
		}else{
			commit('setSetdata',{
				key:'trees',
				data:[]
			})
			commit('setSetdata',{
				key:'jie',
				data:''
			})
			commit('setSetdata',{
				key:'tree_info',
				data:[]
			})
		}

	},
	//获取章节
	async getchapterlistsk({commit,state},param){
		// let {data,code} = await axios.get('https://login.zhuoyuyun.com/index/jiaoxue.Chapter/getChapter',{
		let {data,code} = await axios.get('https://login.zhuoyuyun.com/index/jiaoxue.Chapter/getAllChapter',{
		params:param
		})
		if(code=='10001' && data.length>0){
			commit("setTreessk",{ trees:data});
		}else{
			commit('setSetdata',{
				key:'sktrees',
				data:[]
			})
			commit('setSetdata',{
				key:'skjie',
				data:''
			})
			commit('setSetdata',{
				key:'sktree_info',
				data:[]
			})
		}
	},
	// async getnewchapterlistsk({commit,state},param){
	// 	let {data,code} = await axios.get('https://login.zhuoyuyun.com/index/jiaoxue.Chapter/getOneChapter',{
	// 		params:param
	// 	})

	// 	for(let i=0; i<data.length; i++){
	// 		data[i].value = data[i].id;
	// 		data[i].label = data[i].title;
	// 		data[i].leved = 0;
	// 		data[i].children=[];
	// 		data[i].lid=data[i].id + data[i].title;
	// 		data[i].mid=data[i].id;
	// 		data[i].leaf=false;
	// 	}
	// 	commit('setSetdata',{
	// 		key:'sknewtrees',
	// 		data:data
	// 	})
	// },
	// schoolid	int	学校id	是	否
	// userid	int	用户id	是	否
	// chapterid	int	章	是	否
	// jie	int	节	是	否
	// restype	string	资源分类	是	否
	// order	string	筛选分类	是	否	0表示按时间筛选,1表示按下载量筛选,2等级order
	// sort
	// chapterid
	// 获取资源列表
	async getziyuanlist({commit,state},{schoolid,userid,restype,order,sort,page,size,level,platid,type='mr',xueduan_id,subject_id,version_id,cebie_id,chapterid,jie}={}){
		commit('setSetdata',{
			data:true,
			key:'xbloading'
		})
		let pardata={
			// schoolid:schoolid || window.localStorage.getItem('schoolid'),//int	学校id	是	否
			schoolid:schoolid || window.localStorage.getItem('schoolid'),//int	学校id	是	否
			userid:userid || window.localStorage.getItem('userid'),//	int	用户id	是	否
			// chapterid:chapterid || state.chapterid,//	int	章	是	否

			restype:restype || state.restype,//	string	资源分类	是	否
			order:order || state.order,//	string	筛选分类	是	否	0表示按时间筛选,1表示按下载量筛选,2等级order
			sort:sort || state.sort,//
			page:page || state.xbpage,
			size:size || state.xbpagesize,
			platformid:platid || state.Platactiveid,
			platlevel:level || state.Platlavel,

		}
		if(type=='mr'){
			pardata.xueduan_id=state.chapterides.xueduan_id;
			pardata.subject_id=state.chapterides.subject_id;
			pardata.version_id=state.chapterides.version_id;
			pardata.cebie_id=state.chapterides.cebie_id;
			// pardata.jie=jie || state.jie;//	int	节	是	否
		}else if(type == 'change'){
			xueduan_id==undefined?'':pardata.xueduan_id=xueduan_id;
			subject_id==undefined?'':pardata.subject_id=subject_id;
			version_id==undefined?'':pardata.version_id=version_id;
			cebie_id==undefined?'':pardata.cebie_id=cebie_id;
			chapterid==undefined?'':pardata.chapterid=Number(chapterid);
			jie==undefined?'':pardata.jie=Number(jie);
		}
		let {data,code,info} = await axios({
			url:"index/resource.Schres/getSchreslist",
			method:'GET',
			params:pardata
		})
		if(code=='10001'){
			commit('setSetdata',{
				key:'ziyuanlist',
				data:data
			})
			commit('setSetdata',{
				key:'xbtotal',
				data:info || 0
			})
		}else{
			commit('setSetdata',{
				key:'ziyuanlist',
				data:[]
			})
			commit('setSetdata',{
				key:'xbtotal',
				data:0
			})
		}
		commit('setSetdata',{
			data:false,
			key:'xbloading'
		})
	},
	//资源搜索  index/base.Basedata/search
	// schoolid,userid,chapterid,jie,restype,order,sort,page,size,level,platid,content,type
	async searchziyuanlist({commit,state},{schoolid,userid,jie,restype,order,sort,page,size,level,platid,content,type='mr',typeselect,xueduan_id,subject_id,version_id,cebie_id,chapterid}={}){
		commit('setSetdata',{
			data:true,
			key:'xbloading'
		})
		let pardata={
			schoolid:schoolid || window.localStorage.getItem('schoolid'),//int	学校id	是	否
			// schoolid:schoolid || 110,//int	学校id	是	否
			userid:userid || window.localStorage.getItem('userid'),//	int	用户id	是	否
			// chapterid:chapterid || state.chapterid,//	int	章	是	否

			restype:restype || state.restype,//	string	资源分类	是	否
			order:order || state.order,//	string	筛选分类	是	否	0表示按时间筛选,1表示按下载量筛选,2等级order
			sort:sort || state.sort,//
			page:page || state.xbpage,
			size:size || state.xbpagesize,
			platformid:platid || state.Platactiveid,
			platlevel:level || state.Platlavel,
			content:content || state.searchcontent,
			type:typeselect || state.select,
			// xueduan_id:state.chapterides.xueduan_id,
			// subject_id:state.chapterides.subject_id,
			// version_id:state.chapterides.version_id,
			// cebie_id:state.chapterides.cebie_id
		}
		if(type=='mr'){
			pardata.xueduan_id=state.chapterides.xueduan_id;
			pardata.subject_id=state.chapterides.subject_id;
			pardata.version_id=state.chapterides.version_id;
			pardata.cebie_id=state.chapterides.cebie_id;
			// pardata.jie=jie || state.jie;//	int	节	是	否
		}else if(type == 'change'){
			xueduan_id==undefined?'':pardata.xueduan_id=xueduan_id;
			subject_id==undefined?'':pardata.subject_id=subject_id;
			version_id==undefined?'':pardata.version_id=version_id;
			cebie_id==undefined?'':pardata.cebie_id=cebie_id;
			chapterid==undefined?'':pardata.chapterid=Number(chapterid);
			jie==undefined?'':pardata.jie=Number(jie);
		}

		let {data,code,info} = await axios({
			url:"index/resource.Schres/search",
			method:'GET',
			params:pardata
		})
		if(code=='10001'){
			commit('setSetdata',{
				key:'ziyuanlist',
				data:data
			})
			commit('setSetdata',{
				key:'xbtotal',
				data:info || 0
			})
		}else{
			commit('setSetdata',{
				key:'ziyuanlist',
				data:[]
			})
			commit('setSetdata',{
				key:'xbtotal',
				data:0
			})
		}
		commit('setSetdata',{
			data:false,
			key:'xbloading'
		})
	},

	// 获取资源列表  授课
	async getziyuanlistsk({commit,state},{schoolid,userid,chapterid,jie,restype,order,sort,page,size,level,platid,type}={}){
		commit('setSetdata',{
			data:true,
			key:'skloading'
		})
		let pardata={
			schoolid:schoolid || window.localStorage.getItem('schoolid'),//int	学校id	是	否
			userid:userid || window.localStorage.getItem('userid'),//	int	用户id	是	否
			// chapterid:chapterid || state.skchapterid,//	int	章	是	否
			xueduan_id:state.skchapterides.xueduan_id,
			subject_id:state.skchapterides.subject_id,
			version_id:state.skchapterides.version_id,
			cebie_id:state.skchapterides.cebie_id,
			jie:jie || state.skjie,//	int	节	是	否
			restype:restype || state.skrestype,//	string	资源分类	是	否
			order:order || state.skorder,//	string	筛选分类	是	否	0表示按时间筛选,1表示按下载量筛选,2等级order
			sort:sort || state.sksort,//
			page:page || state.skpage,
			size:size || state.skpagesize,
			platformid:platid || state.skPlatactiveid,
			platlevel:level || state.skPlatlavel
		}
		let {data,code,info} = await axios({
			url:"index/resource.Schres/getSchreslist",
			method:'GET',
			params:pardata
		})
		if(code=='10001'){
			let newlist =[]
			if(type=='scroll'){
				newlist = [...state.skziyuanlist,...data];
			}else{
				newlist = data;
			}

			commit('setSetdata',{
				key:'skziyuanlist',
				data:newlist
			})
			commit('setSetdata',{
				key:'sktotal',
				data:info || 0
			})
		}else{
			commit('setSetdata',{
				key:'skziyuanlist',
				data:[]
			})
			commit('setSetdata',{
				key:'sktotal',
				data:0
			})
		}
		commit('setSetdata',{
			data:false,
			key:'skloading'
		})
	},
	//资源搜索  index/base.Basedata/search
	async searchziyuanlistsk({commit,state},{schoolid,userid,chapterid,jie,restype,order,sort,page,size,level,platid,content,type}={}){
		commit('setSetdata',{
			data:true,
			key:'skloading'
		})
		let pardata={
			schoolid:schoolid || window.localStorage.getItem('schoolid'),//int	学校id	是	否
			userid:userid || window.localStorage.getItem('userid'),//	int	用户id	是	否
			chapterid:chapterid,//	int	章	是	否
			xueduan_id:state.skchapterides.xueduan_id,
			subject_id:state.skchapterides.subject_id,
			version_id:state.skchapterides.version_id,
			cebie_id:state.skchapterides.cebie_id,
			jie:jie || state.skjie,//	int	节	是	否
			restype:restype || state.skrestype,//	string	资源分类	是	否
			order:order || state.skorder,//	string	筛选分类	是	否	0表示按时间筛选,1表示按下载量筛选,2等级order
			sort:sort || state.sksort,//
			page:page || state.skpage,
			size:size || state.skpagesize,
			platformid:platid || state.skPlatactiveid,
			platlevel:level || state.skPlatlavel,
			content:content || state.sksearchcontent,
			type:type || state.skselect
		}
		let {data,code,info} = await axios({
			url:"index/resource.Schres/search",
			method:'GET',
			params:pardata
		})
		if(code=='10001'){
			commit('setSetdata',{
				key:'skziyuanlist',
				data:data
			})
			commit('setSetdata',{
				key:'sktotal',
				data:info || 0
			})
		}else{
			commit('setSetdata',{
				key:'skziyuanlist',
				data:[]
			})
			commit('setSetdata',{
				key:'sktotal',
				data:0
			})
		}
		commit('setSetdata',{
			data:false,
			key:'skloading'
		})
	},
	//获取教材
		async getbook({commit,state},param){
			let pardata={}
			if(param!=''){
				pardata={...param}
			}else{
				pardata={
					cebie_id:state.chapterides['cebie_id'],
					subject_id:state.chapterides['subject_id'],
					version_id:state.chapterides['version_id'],
					xueduan_id:state.chapterides['xueduan_id'],
					// grade_id:0
				}
			}
			let {data,code} = await axios({
				url:'index/jiaoxue.Book/getBookList',
				method:'get',
				params:pardata
			})
			if(code=='10001'){
				commit('setSetdata',{
					key:'bookList',
					data:data
				})
			}else{
				commit('setSetdata',{
					key:'bookList',
					data:[]
				})
			}
		},
	// 备课 获取备课列表
	async getUserBeike({commit,state},{userid,chapterid,jie}={}){
		let {code,data} = await axios({
			url:'index/resource.Beike/getUserBeike',
			method:'get',
			params:{
				userid:userid || window.localStorage.getItem('userid'),
				// chapterid:chapterid || state.skchapterid,
				xueduan_id:state.skchapterides.xueduan_id,
				subject_id:state.skchapterides.subject_id,
				version_id:state.skchapterides.version_id,
				cebie_id:state.skchapterides.cebie_id,
				jie:jie || state.skjie
			}
		})
		if(code=='10001'){
			commit('setSetdata',{
				key:'checkedlist',
				data:data
			})
		}else{
			commit('setSetdata',{
				key:'checkedlist',
				data:[]
			})
		}
	},
	// 授课整理 获取列表
	async getUserShouke({commit,state},{userid,chapterid,jie,pid}={}){
		let pars={
			userid:userid || window.localStorage.getItem('userid'),
			// chapterid:chapterid || state.skchapterid,
			xueduan_id:state.skchapterides.xueduan_id,
			subject_id:state.skchapterides.subject_id,
			version_id:state.skchapterides.version_id,
			cebie_id:state.skchapterides.cebie_id,
			jie:jie || state.skjie
		}
		pid!=undefined?pars.pid=pid:'';
		let {code,data} = await axios({
			url:'index/resource.Beike/getUserShouke',
			method:'get',
			params:pars
		})
		if(pid!=undefined){
			commit('setSetdata',{
				key:'bskchecklistfolder',
				data:data
			})
			commit('setSetdata',{
				key:'floderlist',
				data:[]
			})
			return false
		}
		if(data==null){
			return false
		}
		let arr = state.listcheck;
		let folderlist = data['folder']
		if(code=='10001'){
			for (let i = 0; i < arr.length; i++) {
				for (let j in data) {
					if (arr[i].restype == j) {
						arr[i].list = data[j];
						if(arr[i].list.length>0){
							arr[i].open=true
						}
					}
				}
			}
			commit('setSetdata',{
				key:'bskchecklist',
				data:arr
			})
		}else{
			commit('setSetdata',{
				key:'bskchecklist',
				data:arr
			})
		}
		commit('setSetdata',{
			key:'floderlist',
			data:folderlist
		})
	},
	// 获取校本平台
	// 资源平台等级，1省级，2市级，3区县，4校级，5联盟  0个人
 	async getplatarr({commit,state},{schoolid,userid}={}){
	let {code,data} = await axios({
			url:'index/base.Basedata/getPlatform',
			method:'get',
			params:{
				schoolid:schoolid||window.localStorage.getItem('schoolid'),
				userid:userid || window.localStorage.getItem('userid')
			}
		})
		let defaultstr={
			area_id:0,
			city_id:0,
			id:0,
			level:0,
			province_id:0,
			title:"个人资源"
		}
		let xkw = {
			area_id:0,
			city_id:0,
			id:99,
			level:99,
			province_id:0,
			title:"卓育资源库"
		}
		let xkwzj = {
			area_id:0,
			city_id:0,
			id:100,
			level:100,
			province_id:0,
			title:"卓育组卷"
		}
		let str
		if(data!=null){

			for(let i=0; i<data.length; i++){
				switch(data[i].level){
				     case 4:
				       data[i].title = '校本资源';
					  data[i].logo!=''?window.localStorage.setItem('logo',data[i].logo):window.localStorage.setItem('logo','https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/header/LOGO.png')
				       break;
				     case 3:
				       data[i].title = '区县资源';
				     break;
				     case 2:
				       data[i].title = '市级资源';
				     break;
				     case 1:
				       data[i].title = '省级资源';
				     break;
				   }
			}
			str = [defaultstr,...data,xkw]
		}else{
			 str = [defaultstr,xkw]
		}
		if(window.localStorage.getItem('schoolid') == 110) {
			str.push(xkwzj)
		}
		commit('setSetdata',{
			key:'Plat',
			data:str
		})
		let noewplatid = window.localStorage.getItem('noewplatid')
		 str.forEach((item)=>{
			 if(item.id ==noewplatid){
				commit('setSetdata',{
					key:'Platlavel',
					data:item.level
				})
				commit('setSetdata',{
					key:'Platname',
					data:item.title
				})
				commit('setSetdata',{
					key:'Platactiveid',
					data:item.id
				})
			 }
		 })
		// if(str.length>2){
		// commit('setSetdata',{
		// 	key:'Platlavel',
		// 	data:str[1].level
		// })
		// commit('setSetdata',{
		// 	key:'Platname',
		// 	data:str[1].title
		// })
		// commit('setSetdata',{
		// 	key:'Platactiveid',
		// 	data:str[1].id
		// })
		// }
		window.localStorage.setItem('plat',JSON.stringify(str))
	},









	//-------------------------- 审核列表
	// 待审核资源
	/*
	* userid	int		是	否
    schoolid	int		是	否
    page	int		是	否
    pagesize	int		是	否
	*/
	async getshenhe({commit,state},{userid,schoolid,platformid}={}){
		commit('setSetdata',{
			data:true,
			key:'shloading'
		})
	   let {code,data,info} = await axios({
		   url:'index/resource.Schres/getShenheList',
		   method:'GET',
		   params:{
			   userid:userid || window.localStorage.getItem('userid'),
			   schoolid:schoolid || window.localStorage.getItem('schoolid'),
			   platformid:platformid
			   // page:page || state.shpage,
			   // pagesize:pagesize || state.shpagesize
		   }
	   })
	  commit('setSetdata',{
	  	data:data || [],
	  	key:'ShenheList'
	  })
	  commit('setSetdata',{
	  	data:info || 0,
	  	key:'shtotal'
	  })
	   commit('setSetdata',{
	   	data:false,
	   	key:'shloading'
	   })
	},

	//获取审核过的资源列表
	async getshenhed({commit,state},{userid,schoolid,page,pagesize,status=0}={}){
		// status 0已通过 2已拒绝
		/*
		*shedpage:1,
   shedpagesize:1,
   shedtotal:0
		*/
	   commit('setSetdata',{
	   			data:true,
	   			key:'shloading'
	   		})
	    let {code,data,info} = await axios({
	   		   url:'index/resource.Schres/getUserShenheList',
	   		   method:'GET',
	   		   params:{
	   			   userid:userid || window.localStorage.getItem('userid'),
	   			   schoolid:schoolid || window.localStorage.getItem('schoolid'),
	   			   page:page || state.shedpage,
	   			   pagesize:pagesize || state.shedpagesize,
				   status:status
	   		   }
	    })
	   commit('setSetdata',{
	   	data:data,
	   	key:'ShenheList'
	   })
	   commit('setSetdata',{
	   	data:info || 0,
	   	key:'shedtotal'
	   })
	    commit('setSetdata',{
	    	data:false,
	    	key:'shloading'
	    })

	}




}
export default actions



// WEBPACK FOOTER //
// ./src/store/modules/xiaoben/action.js